module.exports = __webpack_public_path__ + "static/media/protege_tus_datos_3.8699e846.png";